/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ScheduledChangesTickParams } from './scheduledChangesTickParams';

/**
 * Request model for scheduled-changes tick job.
 */
export interface RunScheduledChangesTickJobRequest {
  type: 'scheduled_changes_tick';
  params: ScheduledChangesTickParams;
  allowOverlappingJobs?: boolean;
}
